import './CustomPill.scss';

import React from 'react';

import { Tooltip, TooltipProps } from 'antd';

import { LoadingOutlined } from '@ant-design/icons';

import { useTheme } from '../../context/ThemeProvider';

export interface ICustomPillProps {
  className?: string;
  text: string | number | React.ReactNode;
  shape?: 'pill' | 'circle' | 'square';
  color?: string;
  bgColor?: string;
  textSize?: number;
  width?: number | string;
  height?: number | string;
  paddingX?: number;
  paddingY?: number;
  borderRadius?: number | string;
  border?: number;
  borderColor?: string;
  style?: React.CSSProperties;
  cursor?: React.CSSProperties['cursor'];
  loading?: boolean;
  disabled?: boolean;
  showAsButton?: boolean;
  disableHoverEffect?: boolean;
  onClick?: () => void;
  tooltip?: React.ReactNode;
  tooltipProps?: Partial<TooltipProps>;
}

const CustomPill: React.FC<ICustomPillProps> = ({
  className,
  text,
  shape = 'pill',
  color = '#fff',
  bgColor,
  textSize = 14,
  width = 'auto',
  height = 'auto',
  // paddingX = 8,
  // paddingY = 0,
  paddingX,
  paddingY,
  border = 1,
  borderColor,
  borderRadius,
  style = {},
  cursor,
  loading = false,
  disabled = false,
  showAsButton = false,
  disableHoverEffect = false,
  onClick,
  tooltip,
  tooltipProps,
}) => {
  const { colors: COLORS } = useTheme();

  // if (!text) {
  //   return null;
  // }

  return (
    <Tooltip title={tooltip} {...tooltipProps}>
      <div
        className={`pill-tag ${!disableHoverEffect && (showAsButton || cursor || onClick || style.cursor === 'pointer') ? 'pill-tag--btn' : ''} ${className || ''}`}
        style={{
          color,
          border: `${border}px solid transparent`,
          borderColor: borderColor || bgColor || COLORS.PRIMARY,
          backgroundColor: bgColor || COLORS.PRIMARY,
          fontSize: textSize,
          // padding: `${paddingY}px ${paddingX}px`,
          paddingBlock: paddingY || 0,
          paddingInline: paddingX || (shape === 'pill' ? 8 : 0),
          borderRadius:
            borderRadius ||
            (shape === 'pill' && 50) ||
            (shape === 'circle' && '50%') ||
            4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width,
          height,
          opacity: disabled ? 0.5 : 1,
          filter: disabled ? 'grayscale(1)' : undefined,
          cursor:
            (disabled && 'not-allowed') ||
            (showAsButton || cursor || onClick ? 'pointer' : 'default'),
          ...style,
        }}
        role="button"
        tabIndex={0}
        onClick={disabled ? undefined : onClick}>
        {loading ? (
          <LoadingOutlined style={{ fontSize: textSize, color }} />
        ) : (
          text
        )}
      </div>
    </Tooltip>
  );
};

export default CustomPill;
